import { ApiError } from './ApiError';

// Thrown when Auth0's getAccessTokenSilently resolves without a token (e.g.
// the session has lapsed). It types as `string | undefined`, so callers that
// need an authenticated request use useAccessToken, which throws this
// instead of sending `undefined` on to the backend.
export class MissingAccessTokenError extends ApiError {
  static errorName = 'MissingAccessTokenError';
}
